import { PaywallOverlay, downloadJariFile } from "@jari-tools/shared";
import type { AdventureContent, GameSummary } from "../types/adventure";

const TOOL_SLUG = import.meta.env.VITE_TOOL_SLUG || "act-avontuur";

interface SummaryScreenProps {
  adventure: AdventureContent;
  summary: GameSummary;
  isPaid: boolean;
  portalUrl?: string;
  onRestart: () => void;
}

export function SummaryScreen({
  adventure,
  summary,
  isPaid,
  portalUrl,
  onRestart,
}: SummaryScreenProps) {
  const systemMap = Object.fromEntries(
    adventure.systems.map((s) => [s.id, s])
  );

  const handleSave = () => {
    downloadJariFile(TOOL_SLUG, summary, "act-avontuur-overzicht");
  };

  const handlePrint = () => {
    window.print();
  };

  return (
    <section className="act-summary jari-card">
      <h2>Avontuur voltooid!</h2>
      <p className="act-summary__ending">{adventure.ending}</p>

      <div className="act-summary__stats">
        <div className="act-summary__stat act-summary__stat--good">
          <span className="act-summary__stat-num">
            {summary.selectedHelpful.length}
          </span>
          <span>Helpende gedachten op je dashboard</span>
        </div>
      </div>

      <h3>Gekozen helpende gedachten</h3>
      <ul className="act-summary__thoughts">
        {summary.selectedHelpful.map((t) => {
          const sys = systemMap[t.system];
          return (
            <li key={t.thoughtId} className="act-summary__thought--helpful">
              <span className="act-summary__thought-text">
                {sys?.icon ?? "💭"} {t.text}
              </span>
              <span className="act-summary__thought-status">
                ✓ Op je dashboard gezet
              </span>
            </li>
          );
        })}
      </ul>

      <div className="act-summary__actions">
        <PaywallOverlay
          locked={!isPaid}
          featureTitle="opslaan en printen"
          portalUrl={portalUrl}
        >
          <div className="act-summary__paid-actions">
            <button type="button" className="jari-btn" onClick={handleSave}>
              Opslaan (.jari)
            </button>
            <button type="button" className="jari-btn" onClick={handlePrint}>
              Printen
            </button>
          </div>
        </PaywallOverlay>
        <button type="button" className="jari-btn jari-btn--primary" onClick={onRestart}>
          Nieuw avontuur
        </button>
      </div>
    </section>
  );
}
